import { IAttrValue } from "@multiweb/types/contracts";
import { ButtonCellElement } from "../../../../UI/UI/XGControls/Frames/ColumnTemplates/Cells/ButtonCellElement";
import { ItemTemplate } from "../ItemTemplate";

export class ButtonTemplate extends ItemTemplate {
    //#region Fields
    private _buttonLocKey: string;
    //#endregion Fields

    //#region Methods

    /**
     * Nastaví popisek tlačítka. Pokud není nastaven popisek na pevno (atribut buttonLocKey), použije se hodnota atributu
     */
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        if (!this._buttonLocKey) {
            const value = await this._getJoinData(dataSet, this.parentColumn);
            (item as ButtonCellElement).displayedValue = value;
        }
    }

    public setButtonLocalization(locKey: string): void {
        this._buttonLocKey = locKey;
    }

    protected override _createContentElement(): HTMLElement {
        const cell = new ButtonCellElement();
        cell.initialize(this.parentColumn, this);
        return cell as HTMLElement;
    }

    public get buttonLocKey(): string {
        return this._buttonLocKey;
    }
    //#endregion Methods
}
